/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询剧院首页会员活动、剧院广告位、剧院外景
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.TheaterIndexAdsDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater-index-ads`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
